<template>
  <div class="cencent login_body">
    <div
      style="width: 60%"
      :class="
        u.config().proth == 1
          ? 'loginleft'
          : u.config().proth == 4
          ? 'loginleft1'
          : 'loginleft2'
      "
    >
      <div
        style="
          position: absolute;
          top: 240px;
          text-align: center;
          width: 60%;
          font-size: 65px;
          color: #ffffff;
        "
      >
        {{
          u.config().proth == 1
            ? "服务商管理平台"
            : u.config().proth == 4
            ? "平台管理端"
            : "代理商作业平台"
        }}
      </div>
    </div>
    <div style="width: 40%">
      <div class="login_box">
        <div style="height: 100px"></div>

        <div style="text-align: center">
          <!-- <img src="../../../assets/login/logo.png" style="width: 300px"> -->
        </div>
        <div style="padding: 10px">
          <!-- {{ shenfen }} -->
          <h1 style="text-align: center; margin-bottom: 50px">
            <img
              src="../../../assets/image/ce7e5add440ac2aa0555252ac246892.png"
              alt=""
            />
            <!-- {{
              u.config().proth == 1 ? "服务商管理平台" : u.config().proth == 4 ? "平台管理端" : "代理商作业平台"

            }} -->
          </h1>
          <div style="text-align: center; margin-bottom: 20px">
            <el-tabs v-model="loginType" stretch>
              <el-tab-pane label="验证码登录" name="code"></el-tab-pane>
              <el-tab-pane label="密码登录" name="password"></el-tab-pane>
            </el-tabs>
          </div>
          <el-form ref="form" :model="form" label-width="20px">
            <el-form-item>
              <el-input
                v-model="form.phone"
                clearable
                autocomplete="off"
                maxlength="11"
                placeholder="手机号"
                style="width: 100%"
              ></el-input>
            </el-form-item>

            <el-form-item v-if="loginType === 'code'">
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  flex-wrap: unset;
                "
              >
                <div style="width: 100%">
                  <el-input
                    v-model="form.code"
                    placeholder="验证码"
                    maxlength="6"
                  ></el-input>
                </div>
                <div
                  style="
                    color: #666;
                    text-align: center;
                    width: 0%;
                    cursor: pointer;
                    position: relative;
                    right: 30px;
                    white-space: nowrap;
                  "
                  @click="get_code()"
                >
                  {{ codemsg }}
                </div>
              </div>
            </el-form-item>

            <el-form-item v-if="loginType === 'password'">
              <el-input
                v-model="form.password"
                type="password"
                placeholder="密码"
                style="width: 100%"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <div style="height: 20px"></div>
              <div style="text-align: center">
                <el-button style="width: 240px" @click="login"> 登录</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import u from "../../../assets/js/util";

export default {
  name: "index",
  data() {
    return {
      loginType: "code", // 默认验证码登录
      codemsg: "获取",
      shenfen: "",
      u,
      form: {
        phone: "",
        code: "888888",
        password: "",
      },
    };
  },
  async mounted() {
    var user = await u.post("users", "getuserinfo", {}, 1);
    this.shenfen = window.location.host;
    // this.form.phone = '';
    if (user !== false) {
      window.userinfo = user;
      this.$router.push("/index");
    }
    document.title =
      u.config().proth == 1
        ? "酒管系统服务商平台"
        : u.config().proth == 4
        ? "酒店系统管理平台"
        : "酒管系统代理商作业平台";
  },
  methods: {
    async login() {
      if (!u.isPhone(this.form.phone)) {
        u.error("手机号格式不正确");
        return;
      }

      if (this.loginType === "code" && !this.form.code) {
        u.error("验证码不能为空");
        return;
      }

      if (this.loginType === "password" && !this.form.password) {
        u.error("密码不能为空");
        return;
      }

      var loginherf = u.config().loginUrl;

      var data = await u.post("users", loginherf, {
        phone: this.form.phone,
        code: this.loginType === "code" ? this.form.code : "",
        pwd: this.loginType === "password" ? this.form.password : "",
      });
      if (data !== false) {
        setCookie("AUTH", data.auth, 60 * 60 * 24 * 30);
        window.userinfo = data.userinfo;
        this.$router.push("/index");
      }
    },
    async get_code() {
      if (!u.isPhone(this.form.phone)) {
        u.error("手机号格式不正确");
        return;
      }

      if (this.codemsg != "获取") {
        return;
      }
      this.codemsg = 60;
      var stl = setInterval(() => {
        this.codemsg = this.codemsg - 1;

        if (this.codemsg <= 0) {
          this.codemsg = "获取";
          clearInterval(stl);
        }
      }, 1000);
      var data = await u.post("users", "getcode_admin", {
        phone: this.form.phone,
        temp: "525135",
      });
      if (data === false) {
        u.error("获取失败");
        clearInterval(stl);
        this.codemsg = "获取";
        return;
      }
    },
  },
};

function setCookie(name, val, min) {
  var now = new Date();
  now.setMinutes(now.getMinutes() + min);
  document.cookie = name + "=" + val + ";expires=" + now.toUTCString();
}
</script>

<style scoped>
.login_body {
  background-color: #ffffff;
  width: 100%;
  display: flex;
}

.login_box {
  width: 400px;
  height: 600px;
  margin: 0 auto;
  margin-top: 100px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.loginleft {
  background-image: url("../../../assets/login/loginbanck.png");
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.loginleft1 {
  background-image: url("../../../assets/login/loginbanck1.jpg");
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.loginleft2 {
  background-image: url("../../../assets/login/loginbanck2.jpg");
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

/deep/ .el-input__inner {
  border: 0;
}

/deep/ .el-input__inner {
  border-bottom: solid 1px #cccccc;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/page/module/login/login.vue